module.exports = __webpack_public_path__ + "img/Puente_Istobal_MWASH3PROUSA_Alto_Blanco-default-front.921c0164.jpg";